
import {Utilities} from '../../shared/utilities/utilities.model';
export class DigitalSignClauses {
	id: string;
	clauses: DigitalSignClause[];

	constructor(id?: string) {
		if (!Utilities.isVoid(id)) {
			this.id = id;
		}
		this.clauses = [];
	}

	addClause(clause: DigitalSignClause) {
		this.clauses.push(clause);
	}
}

export class DigitalSignClause {
	id: string;
	value: boolean;

	constructor(id: string, value: boolean) {
		this.id = id;
		this.value = value;
	}
}
